import tailwindConfig from '../../tailwind.config.js';

const getTailwindScreenWidth = (size) => parseInt(tailwindConfig.theme.screens[size].replace('px', ''));

const getters = {
  windowBreakPoint: (state) => {
    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= getTailwindScreenWidth('xl')) return 'xl';
    if (state.windowWidth >= getTailwindScreenWidth('lg')) return 'lg';
    if (state.windowWidth >= getTailwindScreenWidth('md')) return 'md';
    if (state.windowWidth >= getTailwindScreenWidth('sm')) return 'sm';
    return 'xs';
  }
};

export default getters;
